// Whether the review page's cart holds anything to pay for. Reads the same
// cart the page already renders (priorityCart when present, else cart) so no
// second fetch is needed -- CustomerCart shows "Your cart is empty" from the
// same array.
export function cartHasItems(customer) {
  if (!customer) return false;
  const cart = customer.priorityCart || customer.cart;
  return !!(cart && cart.orderPackages && cart.orderPackages.length > 0);
}
